import "./BarcodeReadModal.scss";

import BarcodeReadProvider from "./BarcodeReadProvider";

export default BarcodeReadProvider;
